import './langs/i18n';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

import STORAGE from 'src/constants/localStorage';

import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://2ca53ade1d8930c7392e0b928f028938@o4507690834264064.ingest.us.sentry.io/4507692464734208',
  enabled: location.hostname !== 'localhost',
  integrations: [Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration(), Sentry.replayIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Profiling
  profilesSampleRate: 1.0, // Profile 100% of the transactions. This value is relative to tracesSampleRate
  // Session Replay
  replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.render(<App />, document.getElementById('root'));

if (process.env.REACT_APP_IN_MAINTENACE_MODE === 'true') {
  // log user out if in maintenance mode
  localStorage.removeItem(STORAGE.TOKEN.ACCESS);
  localStorage.removeItem(STORAGE.TOKEN.REFRESH);
}
